export default __webpack_public_path__ + "static/media/leaveHospital.688ac67d.png";